import React from 'react';
import styles from './SearchInput.module.css';

interface SearchInputProps {
  value: string;
  onChange: (value: string) => void;
  placeholder?: string;
  maxWidth?: string;
}

const SearchInput: React.FC<SearchInputProps> = ({
  value,
  onChange,
  placeholder = 'Search...',
  maxWidth = '300px'
}) => {
  const handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    onChange(e.target.value);
  };

  const handleClear = () => {
    onChange('');
  };

  return (
    <div className={styles.container} style={{ maxWidth }}>
      <input
        type="text"
        className={`form-control ${styles.input}`}
        placeholder={placeholder}
        value={value}
        onChange={handleChange}
      />
      <i className={`fas fa-search ${styles.searchIcon}`} />
      {value && (
        <button
          type="button"
          onClick={handleClear}
          aria-label="Clear search"
          className={styles.clearButton}
        >
          <i className="fas fa-times" />
        </button>
      )}
    </div>
  );
};

export default SearchInput;